/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2022 (original work) Open Assessment Technologies SA ;
 */

import assetManagerFactory from 'taoItems/assets/manager';
import assetStrategies from 'taoItems/assets/strategies';
import urlUtil from 'util/url';

/**
 * Asset strategy to load web worker
 */
const webWorkerStrategy = {
    name: 'worker',

    /**
     * Web worker asset strategy handler
     * @param {Object} url - the url object
     * @param {Object} [data]
     * @param {string} [data.workerBase] - the baseUrl for the web worker
     * @returns {string|void} the final URL
     */
    handle(url, data = {}) {
        if (url && urlUtil.isRelative(url) && /worker(\.min)?\.js$/.test(url.file)) {
            if (data.workerBase) {
                return `${data.workerBase.replace(/\/$/, '')}/${encodeURIComponent(url.file.replace(/^\.?\//, ''))}`;
            }
            return url.toString();
        }
    }
};

/**
 * Get a preconfigured asset manager for the Solar Item Runner
 * @param {Object} [data] - initial data
 * @returns {Object} the asset manager
 */
export default function getAssetManager(data = {}) {
    return assetManagerFactory(
        [
            webWorkerStrategy,
            assetStrategies.packedUrl,
            assetStrategies.baseUrl,
            assetStrategies.base64,
            assetStrategies.external
        ],
        data
    );
}
